import type { AxiosPromise } from 'axios'
import request from '@core/request'

/** 博客发布参数接口 */
export interface BlogPublishParams {
  type: number | string
  blogType: number | string // 分类id
  flag: string
  title: string // 博客标题
  intro: string // 博客详情/内容
  pushIntro: string
  count: number // 默认 1
  pushType: number // 默认 1
  postType: number // 默认 1
  startPostTime: string // 默认 ""
  intervalTime: string // 默认 ""
  siteIds: number[]
  // 以下为UI界面有但cURL中未体现的字段，建议根据后端实际需求增删
  website?: string // 网址
  companyName?: string // 公司名称
}

/** 1. 获取产品站点列表 */
export function getProductSiteList(params: { productId: number; siteType: number }): AxiosPromise {
  return request({
    url: '/ydyl-conversion/businessBbs/productSiteList',
    method: 'get',
    baseURL: process.env.VUE_APP_YDYL_BASE_API,
    data: { ...params, _t: Date.now() },
  })
}

/** 2. 获取分类列表(博客文章、海外论坛) */
export function getProductTypeList(): AxiosPromise {
  return request({
    url: '/ydyl-conversion/businessBbs/productTypeList',
    method: 'get',
    baseURL: process.env.VUE_APP_TCLOUD_BASE_API,
    data: { _t: Date.now() },
  })
}
export function getUpdateMediaNew(mid: string): AxiosPromise {
  return request({
    url: '/ydyl-conversion/blogPublish/getUpdateMediaNew',
    method: 'post',
    baseURL: process.env.VUE_APP_TCLOUD_BASE_API,
    data: { mid },
  })
}
export function updateMediaNew(data: BlogPublishParams): AxiosPromise {
  return request({
    url: '/ydyl-conversion/blogPublish/updateMediaNew',
    method: 'post',
    baseURL: process.env.VUE_APP_TCLOUD_BASE_API,
    data,
  })
}
// 4. 获取B2B行业分类列表
export function getB2BIndustryList(): AxiosPromise {
  return request({
    url: '/ydyl-conversion/productMarket/productTypeList',
    method: 'get',
    baseURL: process.env.VUE_APP_YDYL_BASE_API,
    data: { _t: Date.now() },
  })
}
// 5. 获取B2B产品站点列表
export function getB2BProductSiteList(params: { productId: number }): AxiosPromise {
  return request({
    url: '/ydyl-conversion/productMarket/productSiteList',
    method: 'get',
    baseURL: process.env.VUE_APP_YDYL_BASE_API,
    data: { ...params, _t: Date.now() },
  })
}
export function getMarket(id: number): AxiosPromise {
  return request({
    url: '/ydyl-conversion/productMarket/getMarket',
    method: 'get',
    baseURL: process.env.VUE_APP_YDYL_BASE_API,
    data: { id, _t: Date.now() },
  })
}
export function updateMarket(data: any): AxiosPromise {
  return request({
    url: '/ydyl-conversion/productMarket/updateMarket',
    method: 'post',
    baseURL: process.env.VUE_APP_YDYL_BASE_API,
    data,
  })
}
export function busGetUpdateMediaNew(mid: string): AxiosPromise {
  return request({
    url: '/ydyl-conversion/businessBbs/getUpdateMediaNew',
    method: 'post',
    baseURL: process.env.VUE_APP_TCLOUD_BASE_API,
    data: { mid },
  })
}
export function updateBusinessMediaNew(data: any): AxiosPromise {
  return request({
    url: '/ydyl-conversion/businessBbs/updateMediaNew',
    method: 'post',
    baseURL: process.env.VUE_APP_TCLOUD_BASE_API,
    data,
  })
}

/** 3. 最终提交：插入媒体博客 */
export function insertMediaNew(data: BlogPublishParams): AxiosPromise {
  return request({
    url: '/ydyl-conversion/blogPublish/insertMediaNew',
    baseURL: process.env.VUE_APP_TCLOUD_BASE_API,
    method: 'post',
    data,
  })
}
export function Bbs_insertMediaNew(data: BlogPublishParams): AxiosPromise {
  return request({
    url: '/ydyl-conversion/businessBbs/insertMediaNew',
    baseURL: process.env.VUE_APP_YDYL_BASE_API,
    method: 'post',
    data,
  })
}
export function insertMarket(data: BlogPublishParams): AxiosPromise {
  return request({
    url: '/ydyl-conversion/productMarket/insertMarket',
    baseURL: process.env.VUE_APP_YDYL_BASE_API,
    method: 'post',
    data,
  })
}
//  获取站点是否开启
export function getSiteIsOpen(): AxiosPromise {
  return request({
    url: '/obor-nginx-php-ydyl/api/geo/siteIsOpen',
    baseURL: process.env.VUE_APP_YDYL_BASE_API,
    method: 'get',
  })
}
// 获取分类列表
export function getCategory(): AxiosPromise {
  return request({
    url: '/obor-nginx-php-ydyl/api/geo/getCategory',
    baseURL: process.env.VUE_APP_YDYL_BASE_API,
    method: 'get',
  })
}
export type WebsitePublishParams = {
  id?: number
  title: string // 新闻标题
  cate_id: number | null // 分类id
  cate_name: string // 分类名称
  slug: string // 静态地址
  publishTime: number | null // 发布时间
  summary: string // 新闻摘要
  img: string // 新闻图片
  content: string // 新闻内容
  seo: {
    title: string // 新闻标题
    description: string // 新闻摘要
    keywords: string // 新闻关键词
  }
}
// 发布到官网
export function publishWebsite(data: WebsitePublishParams): AxiosPromise {
  return request({
    url: '/obor-nginx-php-ydyl/api/geo/publish',
    baseURL: process.env.VUE_APP_YDYL_BASE_API,
    method: 'post',
    data,
  })
}
// 发布到官网
export function getArticleData(data: WebsitePublishParams): AxiosPromise {
  return request({
    url: '/obor-nginx-php-ydyl/api/geo/article',
    baseURL: process.env.VUE_APP_YDYL_BASE_API,
    method: 'post',
    data,
  })
}
export function ydylPubMedia(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/article/ydylPubMedia',
    data,
  })
}
// 海外媒体发布（PR稿/Reddit）：pubType 固定 20，pubParam.MediaType 10=PR稿(海讯社/媒介易) 12=Reddit(Leadmore)
export function ydylPubOverseasMedia(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/article/ydylPubOverseasMedia',
    data,
  })
}
// Reddit 表单发布（免选媒体）：pubType 20 / pubCount 1，pubParam.form 为表单数据，固定扣点 400、免审核
export function ydylPubRedditMedia(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/article/ydylPubRedditMedia',
    data,
  })
}
// Reddit 发布前搜索 subreddit 话题（display_name 即表单 SubredditName）
export function searchSubreddit(data: { keyword: string }): AxiosPromise {
  return request({
    method: 'post',
    url: '/overseas-media/searchSubreddit',
    data,
  })
}
// 臻选媒体发布
export function addMedia(data: any): AxiosPromise {
  return request({
    method: 'post',
    baseURL: process.env.VUE_APP_TCLOUD_BASE_API,
    url: '/ydyl-digitalmediia/addMedia',
    data,
  })
}

// 获取自媒体矩阵权益 & 资料审核状态
export function Get_Home_HeadDat(data) {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/User_Product/Get_Home_HeadData',
    method: 'post',
    data,
  })
}
// 新增文章
export function addArticle(data: { title: string; content: string }): AxiosPromise {
  return request({
    method: 'post',
    url: '/article/add',
    data,
  })
}
